/* ========================================================================== *\
___________       __         .__
\_   _____/ _____/  |________|__| ____
 |    __)_ /    \   __\_  __ \  |/  _ \
 |        \   |  \  |  |  | \/  (  <_> )
/_______  /___|  /__|  |__|  |__|\____/
        \/     \/
\* ========================================================================== */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';
import { FetchData } from 'services/Request';

// อ่านเฉพาะรูปใหม่ส่งให้ parent ไม่โหลดฟอร์มสินค้าใหม่จนทับร่างช่องอื่น
function GalleryLink({ productId, token, onOpen, fullWidth }) {
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  const sequence = useRef(0);
  const pending = useRef(false);
  useEffect(() => {
    setBusy(false);
    pending.current = false;
    setFailed(false);
    return () => {
      sequence.current += 1;
    };
  }, [productId]);
  const open = () => {
    if (pending.current) return;
    pending.current = true;
    setBusy(true);
    setFailed(false);
    sequence.current += 1;
    const { current } = sequence;
    FetchData('GET', `/product/${productId}`, token, {})
      .then((r) => {
        if (sequence.current !== current) return;
        pending.current = false;
        setBusy(false);
        if (r.status === 'ok' && Array.isArray(r.image)) onOpen(r.image);
        else setFailed(true);
      })
      .catch(() => {
        if (sequence.current === current) {
          pending.current = false;
          setBusy(false);
          setFailed(true);
        }
      });
  };
  return (
    <MDBox data-primary='' sx={fullWidth ? { flexGrow: 1, minWidth: 0 } : undefined}>
      <MDButton
        variant='outlined'
        color='info'
        size='small'
        fullWidth={fullWidth}
        onClick={open}
        disabled={busy}
      >
        {busy ? 'กำลังโหลดรูป…' : 'เปิดแกลเลอรีสินค้า'}
      </MDButton>
      {failed && (
        <MDTypography variant='caption' color='error' display='block'>
          โหลดรูปไม่สำเร็จ กดเปิดแกลเลอรีเพื่อลองใหม่
        </MDTypography>
      )}
    </MDBox>
  );
}
GalleryLink.defaultProps = { fullWidth: false };
GalleryLink.propTypes = {
  productId: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  onOpen: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
};
export default GalleryLink;
